<template>
    <div>
        <public-menu></public-menu>
        <woman-search></woman-search>
        <bottom-nav></bottom-nav>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Woman_search from "@/components/woman/Index.vue"
import Bottom_nav from "@/components/common/bottom-nav"
import Footer from "../../components/Footer.vue"
export default{
    components:{
        'public-menu': Public_menu,
        'woman-search':Woman_search,
        'bottom-nav': Bottom_nav,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');
</style>


// WEBPACK FOOTER //
// src/views/woman/Index.vue